// extracted by mini-css-extract-plugin
module.exports = {"root":"IRnII","label":"_2bYI8","labelIcon":"_3ginT","dropdown":"qmE2I","right":"P6bVC","open":"_1GRtv"};